import React, { useState, useMemo, useCallback, useEffect } from 'react';
import {
  Typography,
  Box,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { useIntl } from 'react-intl';
import { SelectField } from '../../../../../Components/Field';
import { TypedFormFieldValue } from '../../../../../Components/Form/Form.types';
import { StepProps } from './types';
import { StepButtonBar } from './StepButtonBar';
import OtherRequirementInfo from './OtherRequirementInfo';

interface Step4AreaProps extends StepProps {
  areas: { id: number; name: string }[];
  otherRequirementInfo: any;
  setOtherRequirementInfo: (any) => void;
}

const Step4Area: React.FC<Step4AreaProps> = ({
  currentStepName,
  onNext,
  onBack,
  onCancel,
  currentData,
  isFirstStep,
  areas,
  otherRequirementInfo,
  setOtherRequirementInfo,
}) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const paperPadding = isMobile ? theme.spacing(3) : theme.spacing(8);

  const [selectedArea, setSelectedArea] = useState<number | null>(currentData.area || null);

  useEffect(() => {
    if (currentData.area) {
      setSelectedArea(currentData.area);
    }
  }, [currentData.area]);

  const selectOptions = useMemo(
    () => areas.map((a) => ({ value: a.id, label: a.name })),
    [areas],
  );

  const handleAreaChange = useCallback(
    (val: TypedFormFieldValue<number> | TypedFormFieldValue<number>[] | undefined) => {
      if (val && !Array.isArray(val)) {
        setSelectedArea(val.value);
      }
    },
    [],
  );

  const handleNext = () => {
    if (selectedArea) {
      const selectedAreaLabel =
        areas.find((a) => a.id === selectedArea)?.name || '';
      onNext({
        area: selectedArea,
        areaLabel: selectedAreaLabel,
      });
    }
  };

  const isValid = selectedArea;

  return (
    <Box style={{ width: '100%' }}>
      <Box
        style={{
          display: 'flex',
          width: '100%',
          gap: '10px',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'stretch',
        }}
      >
        <Box
          style={{
            width: isMobile ? '100%' : 'calc(50% - 5px)',
            flexShrink: 0,
            padding: paperPadding,
            backgroundColor: '#f7f0f1',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '400px',
          }}
        >
          <Box style={{ maxWidth: '320px', width: '100%' }}>
            {/* Area Field */}
          <Box style={{ marginBottom: theme.spacing(3) }}>
            {/* <Typography
              variant="body2"
              style={{
                fontWeight: 600,
                marginBottom: '4px',
                fontSize: '14px',
              }}
            >
              {formatMessage({
                id: 'utils.filters.area',
                defaultMessage: 'Area',
              })}
              {' '}
              <span style={{ color: 'red' }}>*</span>
            </Typography> */}
            <SelectField
              name="area"
              placeholder={formatMessage({
                id: 'utils.filters.area',
                defaultMessage: 'Area',
              })}
              options={selectOptions}
              errorTexts={[]}
              initialState={
                selectedArea
                  ? { value: selectedArea, label: areas.find((a) => a.id === selectedArea)?.name || '' }
                  : undefined
              }
              onChange={handleAreaChange}
              menuPlacement="auto"
              maxMenuHeight={210}
            />
            </Box>
          </Box>
        </Box>

        <OtherRequirementInfo otherRequirementStepInfo={otherRequirementInfo} currentStepName={currentStepName} onUpdate={setOtherRequirementInfo} />
      </Box>

      <StepButtonBar
        onCancel={onCancel}
        onBack={onBack}
        onNext={handleNext}
        nextLabel="form.next"
        nextDisabled={!isValid}
        formatMessage={formatMessage}
        showBack={true}
      />
    </Box>
  );
};

export default Step4Area;
